/**
 * O menu sai inteiro dos modulos.
 *
 * Cada `resources/modules/<nome>/routes.js` exporta `nav` ao lado das rotas;
 * este arquivo so os coleta. Nao ha `legacyNavConfig` aqui -- o ata nasceu
 * com o desenho de modulos (herdado do deck), e manter o merge seria
 * carregar um arquivo que so existe para estar vazio.
 *
 * E o UNICO arquivo do projeto com `import.meta.glob`, que e do Vite. Toda a
 * logica de montar menu vive em navFromModules.js e moduleMenu.js, que
 * rodam sob `node --test` sem bundler -- e e por isso que sao testados.
 */
import { navFromModules, navsFromModules, declaredModules } from './navFromModules.js';

const modules = import.meta.glob('@/modules/*/routes.js', { eager: true });

export const navConfig = navFromModules(modules);

/** Declaracoes cruas, consumidas pelo buildModuleMenu(). */
export const declaredNavs = navsFromModules(modules);

/** Usado pelo menu de reserva -- ver declaredModules(). */
export const fallbackNav = declaredModules(modules);
